var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('div', {
    staticClass: "num font-size-12 font-size-lg-14 font-weight-bold color-white text-center d-flex align-center justify-center bg-black",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.num))])]), _c('div', {
    class: 'num-content ' + _vm.space,
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }